import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  screenTitle: {
    defaultMessage: 'Details',
    description: 'Product Details | Screen title',
  },
  goBack: {
    defaultMessage: 'Go back',
    description: 'Product Details | Go back',
  },
  superIngredientsTitle: {
    defaultMessage: 'Super Ingredients',
    description: 'Product Details | Super Ingredients title',
  },
  nutritionInfoTitle: {
    defaultMessage: 'Nutrition Info',
    description: 'Product Details | Nutrition Info title',
  },
});
